
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.775 8.664a.5.5 0 00.183-.683l-2-3.464a.5.5 0 00-.3-.233.5.5 0 00-.379.05L14.5 7.669V1a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v6.668L3.725 4.334a.5.5 0 00-.683.183l-2 3.464a.5.5 0 00.183.683L7 12l-5.775 3.334a.5.5 0 00-.183.683l2 3.464a.5.5 0 00.683.183L9.5 16.329V23a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-6.671l5.776 3.335a.5.5 0 00.379.05.5.5 0 00.3-.233l2-3.464a.5.5 0 00-.183-.683L17 12l5.775-3.336z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    